import { _assert } from '@naturalcycles/js-lib/error'
import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { getStudioData, getStudioRentalPageData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { StudioPage } from '#src/pages/services/studio-rental/StudioPage.js'
import { alternatesMeta, mergeMeta, noindexUnlessTranslated, seoTagsToMeta } from '#src/seo.js'
import type { Route } from './+types/studio-rental.route.js'

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const pageData = await getStudioRentalPageData(lang)
  const [studio] = pageData.studios
  _assert(studio, 'at least 1 studio should exist')
  const data = await getStudioData(studio.id, lang)

  const meta = [
    ...seoTagsToMeta(data.seo),
    ...alternatesMeta('/services/studio-rental', lang),
    ...noindexUnlessTranslated('/services/studio-rental', lang),
  ]
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function StudioPageLayout({ loaderData }: Route.ComponentProps): ReactNode {
  return (
    <StudioPage data={loaderData.data}>
      <Outlet />
    </StudioPage>
  )
}
